import { render, staticRenderFns } from "./ModernMultiversalDimensionsTab.vue?vue&type=template&id=855b7b9e&"
import script from "./ModernMultiversalDimensionsTab.vue?vue&type=script&lang=js&"
export * from "./ModernMultiversalDimensionsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports